import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-locize-backend";
import { useCallback, useEffect, useMemo, useState } from "react";
import { initReactI18next, useTranslation } from "react-i18next";
import { AuthService } from "../store/auth/service";
import { useFetchable } from "../store/common/fetchable";
import { isFetchableSuccess } from "../store/common/fetchable/helpers";
import { Users } from "../store/users/reducer";

const locizeOptions = {
  projectId: "a65b62b1-6339-46f1-96fd-c00ded5a7246",
  apiKey: "dbb4ede1-031e-4e75-8462-c219be762a19", // The API key should only be used in development, not in production. You should not expose your apps API key to production!!!
  referenceLng: "en-GB",
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === "development",
    fallbackLng: "en-GB",
    saveMissing: true,
    interpolation: {
      escapeValue: false,
    },
    react: {},
    backend: locizeOptions,
  });

export const flags = {
  "en-GB": "🇬🇧",
  "es-ES": "🇪🇸",
};

export const languageTitles = {
  en_GB: "English",
  es_ES: "Español",
};

export const useLanguages = () => {
  const [languages, setLngs] = useState({
    "en-GB": {
      name: "English",
      nativeName: "English",
      isReferenceLanguage: true,
      region: "GB",
    },
  });

  // Load Languages from Locize
  useEffect(() => {
    i18n.services.backendConnector.backend.getLanguages(
      (err: any, ret: any) => {
        if (err) return; // TODO: handle err...
        setLngs(ret);
      }
    );
  }, []);

  const selectLanguage = useCallback(
    (lang, doNotPersist = false) => {
      i18n.changeLanguage(lang);
      if (!doNotPersist) {
        AuthService.setUserLocale(lang.replace("-", "_"));
      }
    },
    [i18n]
  );

  return {
    languages,
    selectLanguage,
    current: useMemo(() => i18n.language, [i18n]),
  };
};

export const useLoadUserLanguage = () => {
  const user = useFetchable(Users.current);

  useEffect(() => {
    if (isFetchableSuccess(user)) {
      if (i18n.language.replaceAll("-", "_") !== user.data.locale) {
        i18n.changeLanguage(user.data.locale.replaceAll("_", "-"));
      }
    }
  }, [user]);
};

export const useDefaultToEnglish = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage("en-GB");
  }, []);
};

export default i18n;
